export function drawGlobalFooter(pdf, margin = 40, timestamp) {
  const [date, time] = timestamp.split(" ");
  const pageCount = pdf.internal.getNumberOfPages();
  const pageHeight = pdf.internal.pageSize.getHeight();

  for (let i = 1; i <= pageCount; i++) {
    pdf.setPage(i);
    pdf.setFontSize(9);
    pdf.setFont("helvetica", "normal");
    pdf.text(
      `Informe de trazabilidad y temperatura generado por: Correos Frío                           Fichero generado: ${date.replace(
        /-/g,
        "/"
      )} a las ${time}`,
      margin + 5,
      pageHeight - 10
    );
  }
}
